module.exports = __webpack_public_path__ + "static/potato-a666361a4613f9d5ffd79a869b8b50f0.svg";